import { render, staticRenderFns } from "./WxCheckboxWeekdays.vue?vue&type=template&id=c532cf6c&scoped=true"
import script from "./WxCheckboxWeekdays.vue?vue&type=script&lang=js"
export * from "./WxCheckboxWeekdays.vue?vue&type=script&lang=js"
import style0 from "./WxCheckboxWeekdays.vue?vue&type=style&index=0&id=c532cf6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c532cf6c",
  null
  
)

export default component.exports